var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 16.1842,
    r: 16.1842,
    fill: "#F5EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0852 12.1365C12.1038 12.1365 12.9295 11.3108 12.9295 10.2924C12.9295 9.27388 12.1038 8.44824 11.0852 8.44824C10.0666 8.44824 9.24084 9.27388 9.24084 10.2924C9.24084 11.3108 10.0666 12.1365 11.0852 12.1365Z",
    fill: "#3C1D59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.671 13.5341V23.7653H17.848V18.7057C17.848 17.3707 18.0992 16.0778 19.7547 16.0778C21.3875 16.0778 21.4077 17.6041 21.4077 18.79V23.7661H24.5864V18.1554C24.5864 15.3993 23.993 13.2812 20.7713 13.2812C19.2245 13.2812 18.1877 14.13 17.7637 14.9332H17.7207V13.5341H14.671ZM9.49377 13.5341H12.6758V23.7653H9.49377V13.5341Z",
    fill: "#3C1D59"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1c22aed5b4e8a605e00b2705cabc2d73.svg";
export { ForwardRef as ReactComponent };